'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduleRow = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _tzOffsets = require('tz-offsets');

var _tzOffsets2 = _interopRequireDefault(_tzOffsets);

var _StarRating = require('../StarRating/StarRating');

var _ScheduleCta = require('./ScheduleCta');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScheduleRow = exports.ScheduleRow = function ScheduleRow(_ref) {
  var activities = _ref.activities,
      availableToReserve = _ref.availableToReserve,
      className = _ref.className,
      callToAction = _ref.callToAction,
      creditPrice = _ref.creditPrice,
      creditsReasons = _ref.creditsReasons,
      endTime = _ref.endTime,
      hideCta = _ref.hideCta,
      itemUrl = _ref.itemUrl,
      label = _ref.label,
      onReserveClicked = _ref.onReserveClicked,
      purchaseAmount = _ref.purchaseAmount,
      purchaseCurrency = _ref.purchaseCurrency,
      rating = _ref.rating,
      reasonCannotReserve = _ref.reasonCannotReserve,
      schedule = _ref.schedule,
      startTime = _ref.startTime,
      teacherName = _ref.teacherName,
      timeZone = _ref.timeZone;

  var reason = creditsReasons || reasonCannotReserve;

  return _react2.default.createElement(
    'div',
    { className: 'schedule__row' },
    _react2.default.createElement(
      'div',
      { className: 'schedule__row__date' },
      _react2.default.createElement(
        'time',
        { className: 'schedule__row__date__time' },
        _react2.default.createElement(_reactIntl.FormattedTime, {
          value: new Date((0, _tzOffsets2.default)(startTime, timeZone) * 1e3),
          hour12: true,
          hour: 'numeric',
          minute: 'numeric'
        })
      ),
      _react2.default.createElement(
        'span',
        { className: 'schedule__row__date__duration' },
        (0, _moment2.default)(endTime, 'X').diff((0, _moment2.default)(startTime, 'X'), 'minutes') + ' min'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'schedule__row__classinfo' },
      _react2.default.createElement(
        'strong',
        null,
        itemUrl ? _react2.default.createElement(
          _reactRouter.Link,
          { to: itemUrl },
          className
        ) : className
      ),
      teacherName,
      !!rating && _react2.default.createElement(_StarRating.StarRating, {
        className: 'schedule__row__classinfo__rating',
        rating: rating,
        showRatingNumber: true
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'schedule__row__activity' },
      activities
    ),
    !hideCta && _react2.default.createElement(
      'div',
      { className: 'schedule__row__cta' },
      purchaseAmount && _react2.default.createElement(
        'div',
        { className: 'schedule__row__cta__add-info' },
        _react2.default.createElement(_reactIntl.FormattedNumber, {
          id: 'schedule.row.cta-pricing',
          value: purchaseAmount,
          style: 'currency',
          currency: purchaseCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      ),
      _react2.default.createElement(_ScheduleCta.ScheduleCta, {
        action: callToAction,
        className: 'tooltip tooltip--right tooltip--md-center',
        creditPrice: creditPrice,
        onClick: onReserveClicked,
        schedule: schedule,
        tooltip: !availableToReserve && reason
      }),
      label && _react2.default.createElement(
        'span',
        { className: 'schedule__row__label' },
        label
      )
    ),
    reason && _react2.default.createElement(
      'div',
      { className: 'schedule__row__reason' },
      reason
    )
  );
};

ScheduleRow.propTypes = {
  activities: _propTypes2.default.string,
  availableToReserve: _propTypes2.default.bool,
  className: _propTypes2.default.string.isRequired,
  callToAction: _propTypes2.default.string.isRequired,
  creditPrice: _propTypes2.default.number,
  creditsReasons: _propTypes2.default.string,
  endTime: _propTypes2.default.number.isRequired,
  hideCta: _propTypes2.default.bool,
  itemUrl: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onReserveClicked: _propTypes2.default.func,
  purchaseAmount: _propTypes2.default.number,
  purchaseCurrency: _propTypes2.default.string,
  rating: _propTypes2.default.number,
  reasonCannotReserve: _propTypes2.default.string,
  schedule: _propTypes2.default.object,
  startTime: _propTypes2.default.number.isRequired,
  teacherName: _propTypes2.default.string,
  timeZone: _propTypes2.default.string.isRequired
};